import { Link } from 'react-router-dom';

export default function Footer() {
  const articleLinks = [
    { name: 'Ultimate Guide', slug: '/basetao-spreadsheet-guide' },
    { name: 'Basetao Review', slug: '/basetao-review' },
    { name: 'Shipping Cost', slug: '/basetao-shipping-cost' },
    { name: 'Coupons', slug: '/basetao-coupon' },
    { name: 'Warehouse Guide', slug: '/basetao-warehouse' },
    { name: 'Is Basetao Legit?', slug: '/is-basetao-legit' },
    { name: 'Best Finds', slug: '/basetao-finds' },
    { name: 'Alternatives', slug: '/basetao-alternatives' },
    { name: 'Shipping Calculator', slug: '/basetao-shipping-calculator' },
    { name: 'Beginner Guide', slug: '/basetao-beginner-guide' },
    { name: 'vs Superbuy', slug: '/basetao-vs-superbuy' },
    { name: 'vs Sugargoo', slug: '/basetao-vs-sugargoo' },
    { name: 'vs Pandabuy', slug: '/basetao-vs-pandabuy' },
    { name: 'Europe Shipping', slug: '/basetao-europe-shipping' },
    { name: 'USA Shipping', slug: '/basetao-usa-shipping' },
    { name: 'QC Photos', slug: '/basetao-qc-photos' },
    { name: 'Tracking', slug: '/basetao-tracking-guide' },
    { name: 'Budget Finds', slug: '/budget-basetao-finds' },
    { name: 'Tips & Tricks', slug: '/basetao-spreadsheet-tips' },
    { name: 'Discount Codes', slug: '/basetao-discount-code' },
  ];

  return (
    <footer className="py-12 md:py-14 px-4 md:px-6 bg-secondary-100">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-file-list-3-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950 whitespace-nowrap">
                Basetao Spreadsheet
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your trusted resource for curated product discovery. Find the best Basetao products, guides, reviews, and shopping resources all in one place.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-900 text-sm mb-4">Shopping Guides</h4>
            <div className="grid grid-cols-2 gap-2">
              {articleLinks.map((link) => (
                <Link
                  key={link.slug}
                  to={link.slug}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-900 text-sm mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">Home</Link>
              <Link to="/basetao-spreadsheet-guide" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">Ultimate Guide</Link>
              <Link to="/basetao-review" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">Basetao Review</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">Main Website</a>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; {new Date().getFullYear()} Basetao Spreadsheet Hub. Your trusted resource for curated product discovery.
          </p>
          <div className="flex items-center gap-4 text-sm text-foreground-500">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-600 transition-colors">
              Visit Main Website
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}